import React, { FC, useCallback } from 'react'
import CoreInput from 'components/Core/CoreInput'
import CoreButton from 'components/Core/CoreButton'

interface RescheduleReasonProps {
  reason: string
  setReason: (reason: string) => void
  setGotReason: (gotReason: boolean) => void
}

const RescheduleReason: FC<RescheduleReasonProps> = ({ reason, setReason, setGotReason }) => {
  const handleContinueClick = useCallback(() => {
    if (reason) setGotReason(true)
  }, [reason, setGotReason])

  return (
    <div className="tw:flex tw:flex-col tw:gap-4 tw:min-h-full tw:grow tw:px-2 tw:pb-6 sm:tw-pb-0">
      <section className="tw:grow">
        <p className="tw:text-xl tw:font-bold tw:tracking-tight tw:mb-4 tw:text-center tw:md:text-left">
          {'Why do you need to reschedule?'}
        </p>
        <CoreInput.TextArea
          autoFocus
          value={reason}
          onChangeText={setReason}
          required
          placeholder="Please specify the reason to reschedule"
          elementSize="l"
          rows={8}
          maxLength={32768}
        />
      </section>
      <footer className="tw:flex tw:flex-col tw:justify-center tw:gap-2 tw:sticky tw:bottom-0 tw:px-6">
        <CoreButton
          type="button"
          size="l"
          kind={!reason ? 'disabled' : 'primary'}
          disabled={!reason}
          text="Continue"
          onClick={handleContinueClick}
        />
      </footer>
    </div>
  )
}

export default RescheduleReason
